<template lang="pug">
include /mixins
+b.ticket-form
  +e.head
    +e.title.H1 {{ _('Анкета участника') }}
    +b.ambassador-steps
      +b.ambassador-step(
        v-for='step in steps'
        :key='step'
        @click='goNext(step)'
        :class='{ "is-active": step === currentStep, "is-past": step < currentStep }'
      ) 0{{ step }}

  +b.VALIDATION-OBSERVER(
    ref="validator",
    v-slot="{ valid }",
    tag="form",
  )
    ui-loader(v-if='isLoad')
    +b.form-fields(
      v-for='{ fields, title } in form_fields[currentStep-1]'
      v-if='currentStep < 3'
    )
      +e.title.P {{ title }}
      +b.g-row
        +b.g-cell.g-cols--12.tt-space_mt--6(
          v-for='{ rules, name, label, tag, classname,events, errorClasses, mask, type, props } in fields'
        )
          tag(
            :tag='tag || "d-control-input"'
            :rules="rules",
            :input-label='label'
            v-model='form[name]',
            :ref='name'
            v-bind='props'
            v-on='events'
            @input='$emit("update", form)'
            :name='name'
            :type='type || "text"'
            :key='name'
            :class='classname',
            :error-classes='errorClasses'
          )
    +b.tt-space_mt--6
      +b.tt-button--auto.BUTTON(
        type='submit'
        :disabled='isLoad',
        @click.prevent='goNext'
      )
        +e.title.P {{ _('Отправить') }}

</template>
<script>
import {
  pathOr,
} from 'ramda'
import {
  createTicket,
  TICKET_SUBJECT_OF_APPEAL_LIST_URL,
  TICKET_FEEDBACK_METHOD_LIST_URL,
  getTypeOfAppeals,
} from '@api/ticket.service'

import {
  NOVAPOSHTA_CITIES_LINK,
} from '@api/order.service'

import {
  getCookie,
} from '@utils/cookies'

import {
  COUNTRY_CODE_COOKIE_NAME,
  UKRAINE_CODE,
} from '@app/consts'

import {
  AnswerMessage,
} from '@utils/submit'

import {
  getPaginatedPropsForArray,
} from '@utils/valuesGetter'

import {
  TICKET_LIST_NAME,
} from '@app/Staff/Ticket/routes'

import TicketFileLoader from '@app/Staff/Ticket/FileLoader'

import { decodeHTMLEntities } from '@utils/helpers'

import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'

const IS_PHONE = 'phone'
const IS_EMAIL = 'email'
const IS_OTHER = 'other'

export default {
  name: 'TicketCreate',
  mixins: [FormMixin],
  props: {
    type: {
      required: true,
    },
  },
  components: {
    TicketFileLoader,
  },
  data() {
    return {
      steps: [1, 2, 3],
      currentStep: 1,
      appeals: [],
      form_fields: [[
        {
          title: this._('Укажите Вашу фамиию, имя и отчество на украинском языке'),
          fields: [
            {
              name: 'last_name',
              label: this._('Фамилия'),
              rules: 'required',
            },
            {
              name: 'first_name',
              label: this._('Имя'),
              rules: 'required',
            },
            {
              name: 'middle_name',
              label: this._('Отчество'),
              rules: 'required',
            },
          ],
        },
        {
          title: this._('Пожалуста, укажите актуальный номер телефона'),
          fields: [
            {
              name: 'phone',
              label: this._('Номер телефона'),
              rules: 'required|phone',
              tag: 'phone-input',
            },
          ],
          description: this._('Обратите внимание: номер телефона должен быть правильным, поскольку на него могут приходить подтвержение по SMS и сообщения об активации билета.'),
        },
        {
          title: this._('Укажите актуальную электронную почту'),
          fields: [
            {
              name: 'email',
              label: this._('Электронная почта'),
              rules: 'required|email',
            },
          ],
          description: this._('На этот адрес могут приходить важные сообшение о верификации и участии в саммите.'),
        },
      ]],
      form: {
        name: decodeHTMLEntities(`${window.request_name || ''} ${window.request_lastname || ''}`),
        phone: window.request_phone,
        city: '',
        comment: '',
        social_activity: '',
        specialization: '',
        reason: '',
        instagram: '',
        facebook: '',
        not_used_brands: false,
        brands_wishlist: [],
        brands_used: [],
      },
      summary: [
        {
          title: this._('Ваше ФИО'),
          value: 'name',
          cols: '12 6-xl',
        },
        {
          title: this._('Город, где вы проживаете'),
          value: 'city',
          cols: '12 6-xl',
        },
        {
          title: this._('Номер телефона'),
          value: 'phone',
          cols: '12 6-xl',
        },
        {
          title: this._('Специализация'),
          value: 'specialization',
          cols: '12 6-xl',
        },
        {
          title: this._('Ссылка на ваш Instagram аккаунт'),
          value: 'instagram',
          cols: '12 6-xl',
        },
        {
          title: this._('Ссылка на ваш Facebook аккаунт'),
          value: 'facebook',
          cols: '12 6-xl',
        },
        {
          title: this._('Как часто вы публикуете контент в соцсетях?'),
          value: 'social_activity',
          cols: '12',
        },
        {
          title: this._('Какие бренды TOTIS Pharma вы используете в работе?'),
          value: 'brands_used',
          getter: arr => arr.map(item => item.props.title).join(', '),
          cols: '12',
        },
        {
          title: this._('Какие бренды вы бы хотели представлять как амбассадор TOTIS Pharma?'),
          value: 'brands_wishlist',
          getter: arr => arr.map(item => item.props.title).join(', '),
          cols: '12',
        },
        {
          title: this._('Почему вы бы хотели представлять эти бренды как амбассадор TOTIS Pharma?'),
          value: 'reason',
          cols: '12',
        },
      ],
      form: {
        first_name: decodeHTMLEntities(window.request_name),
        last_name: decodeHTMLEntities(window.request_lastname),
        message: '',
        type: this.type,
        subject: null,
        settlement: null,
        files: [],
        feedback_method: null,
      },
      non_field_errors: '',
      isLoad: false,
      currentType: null,
    }
  },
  watch: {
    'form.subject': {
      deep: true,
      handler() {
        const r = pathOr(false, ['props', 'attachment_is_required'], this.form.subject)
        this.form_fields[1].fields[0].rules = { required: r }
      },
    },
  },
  mounted() {
    this.getTypes()
  },
  methods: {
    async goNext(step) {
      if (this.$refs.validator) this.$refs.validator.reset()
      if (this.currentStep === step) return;
      if (this.currentStep > step) {
        this.currentStep = step
        return
      }
      const isValid = (await this.$refs.validator.validate())
      if (!isValid) return
      if (this.currentStep === this.steps.length) {
        this.prepareData(isValid)
        return
      }
      this.currentStep += 1
      if (this.$refs.validator) this.$refs.validator.reset()
    },
    async getTypes() {
      const { data: { items } } = (await getTypeOfAppeals.execute({}))
      this.appeals = items
      // this.currentType = this.appeals.find(item => item.id === this.type)
      // const r = pathOr(false, ['props', 'attachment_is_required'], this.currentType)
      // this.form_fields[1].fields[0].rules = { required: r }
      // this.form_fields[1].fields[0].props.canAdd = this.form.files.length < 3
    },
    setDefault() {
      const feedbackMethod = pathOr(null, ['props', 'input_field_type'], this.form.feedback_method)
      if (feedbackMethod) {
        if (feedbackMethod === IS_PHONE) {
          this.form.feedback_contact = window.request_phone
        } else if (feedbackMethod === IS_EMAIL) {
          this.form.feedback_contact = window.request_email
        } else if (feedbackMethod === IS_OTHER) {
          this.form.feedback_contact = ''
        }
      }
    },
    async prepareData(valid) {
      await this.$refs.validator.validate()
      if (!valid) return
      const data = JSON.parse(JSON.stringify(this.form))
      data.subject = pathOr('', ['id'], this.form.subject)
      data.settlement = pathOr('', ['id'], this.form.settlement)
      data.feedback_method = pathOr('', ['id'], this.form.feedback_method)
      data.files = data.files.map(item => item.id)
      this.submit(valid, data)
    },
    send(data) {
      return createTicket.execute({}, data)
        .then(res => {
          // window.dataLayer = window.dataLayer || []
          // window.dataLayer.push({ event: 'event_registration_topic' })
          const message = {
            message: {
              title: this._('Ticket create success header'),
              text: this._('Ticket create success text'),
            },
          }
          AnswerMessage(message, this)
          this.$refs.validator.$el.reset()
          this.$refs.validator.reset()
          this.form.message = ''
          this.$emit('close')
          this.$router.push({
            name: TICKET_LIST_NAME,
          })
        })
    },
    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.non_field_errors = parsed.non_field_errors
      this.$refs.validator.setErrors(parsed)
    },
  },
}
</script>
